import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import PurposesListContentComponent from './PurposesListContentComponent';

class PurposesListComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <PurposesListContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default PurposesListComponent;